import { render, staticRenderFns } from "./PropostaTerapeuticaList.vue?vue&type=template&id=a9e00b00"
import script from "./PropostaTerapeuticaList.vue?vue&type=script&lang=js"
export * from "./PropostaTerapeuticaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports